<header (click)="closeMenu($event)">

  @if (showBreadcrumb()) {
    <breadcrumb class="breadcrumb-header-nav" [formTitle]="viewTitle"></breadcrumb>
  }
  <!--<p class="header-title" *ngIf="currentUrl.includes('cms/dashboard')" [innerHTML]="headerText"></p>-->
  <!--<breadcrumb [allowBootstrap]="true"></breadcrumb>-->

  <!--<div class="title-holder">
  <h1>{{viewTitle}}</h1>
</div>-->

<div class="wrapper">

  <!--<div class="notifications" (click)="notificationsClick()">
  <span class="tooltip-text tooltip-text-notifications">Opravila</span>
</div>
<div class="empty"></div>

<div class="help-support" (click)="helpSupport()">
  <span class="tooltip-text tooltip-text-support">Pomoč</span>
</div>-->


@for (node of customNodes; track node) {
  <div class="custom-header-menu-container">
    @if (node.Children.length == 0) {
      <div class="header-menu-custom-node img {{node.Icon}}"
        (click)="topMenuItemClick(node)">
        @if (node.TooltipText != null) {
          <span class="tooltip-text tooltip-text-custom-node">{{node.TooltipText}}</span>
        }
      </div>
    }
    @if (node.Children.length > 0) {
      <div class="header-menu-custom-node img {{node.Icon}}"
        (click)="openChildrenNodes(node)">
        @if (node.TooltipText != null) {
          <span class="tooltip-text tooltip-text-custom-node">{{node.TooltipText}}</span>
        }
        @if (childrenNodes[node.Id]?.Show) {
          <div class="custom-header-node-children">
            @for (child of node.Children; track child) {
              <div class="child-item" (click)="topMenuItemClick(child)">
                <div class="item-text">
                  <p>{{translationsService.translate(child.OriginalTitle)}}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="empty"></div>
  </div>
}

@if (showPlatformIcon) {
  <div class="platform-icon-container">
    <div class="header-menu-custom-node img platform-icon-img" (click)="navigateToPlatform()">
      <span class="tooltip-text tooltip-text-custom-node">platforma</span>
    </div>
  </div>
}

<div class="user" (click)="userMenuClick()">
  @if (!showOnlyUser) {
    <img class="user-image" src="../../../../assets/css/images/platform/ikona-user@2x.png" alt="User"
      >
  }
  @if (showOnlyUser) {
    <p class="user-text" style="background: none;">{{restProvider.currentUser.FullName}}
    </p>
  }

  @if (userMenuState) {
    <div class="top-menu users">
      <div class="top-menu-item" (click)="userPopupClick()">
        <div class="img user-profile-icon-img"></div>
        <div class="item-text">
          <p>{{translationsService.translate('WebGalis_ProfilePage')}}</p>
        </div>
      </div>
      @if (instructionsUrl) {
        <div class="top-menu-item" (click)="openInstructions()">
          <div class="img instructions-help-icon-img"></div>
          <div class="item-text">
            <p>Navodila</p>
          </div>
        </div>
      }
      @for (node of userMenuResult; track node) {
        <div class="top-menu-item" (click)="topMenuItemClick(node)">
          <div class="img {{node.Icon}}"></div>
          <div class="item-text">
            <p>{{translationsService.translate(node.OriginalTitle)}}</p>
          </div>
        </div>
      }
      <div class="top-menu-item version-dd-val">
        <div class="item-text">
          <p>{{translationsService.translate('Version')}}: {{version}}</p>
        </div>
      </div>
    </div>
  }
  @if (restProvider.currentUser && restProvider.currentUser.Username && !showOnlyUser) {
    <span
      class="tooltip-text tooltip-text-user">{{translationService.translate('SignedInAs')}}
    {{restProvider.currentUser.Username}}</span>
  }
</div>

@for (node of formActionResponses; track node) {
  <div class="form-action-evals">
    <p>{{node}}</p>
  </div>
}

<div class="empty"></div>

@if ( !showOnlyUser) {
  <div class="language-picker" (click)="languageMenuClick()">
    <p>{{currentLanguage}}</p>
    @if (languageMenuState) {
      <div class="top-menu">
        @for (node of languageMenuResult; track node) {
          <div class="item-wrapper">
            <div class="top-menu-item" (click)="languageChange(node.Title)">
              <div class="item-text">
                <p>{{translationsService.translate(node.OriginalTitle)}}</p>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div></div>
    <span
    class="tooltip-text tooltip-text-language">{{translationService.translate('galis_js_language_tooltiptext')}}</span>
  </div>
}

</div>
</header>